import { entriesReducerFactory } from '@/fleet-configuration/data-fleet/entries/entries-reducer-factory'
import { SET_DEVICES_CALIBRATION } from './devices-calibrations-actions.js'

export const devicesCalibrationsReducer = entriesReducerFactory(SET_DEVICES_CALIBRATION)
